import React from "react";

import Button from "material-ui/Button";
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "material-ui/Dialog";
import { CircularProgress } from "material-ui/Progress";
import { withStyles } from "material-ui/styles";
import isMobile from "ismobilejs";

const styles = theme => ({
  dialogContent: {
    minWidth: 500,
    maxWidth: 600,
    border: "none"
  },
  contentText: {
    whiteSpace: "pre-line"
  },
  cautionBtn: {
    backgroundColor: theme.palette.remove.dark,
    "&:hover": {
      backgroundColor: theme.palette.remove.light
    }
  },
  buttonProgress: {
    color: "#007eff",
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
    minWidth: 24
  }
});

const mobileStyles = () => ({
  dialogTitle: {
    padding: 10
  },
  dialogActions: {
    margin: 5
  }
});

class ConfirmDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      spin: false
    };
  }
  render() {
    const { props } = this;
    const { confirmDialog, classes } = props;

    return (
      <Dialog
        disableBackdropClick
        open={confirmDialog.open}
        onClose={props.handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className={classes.dialogTitle}>
          {confirmDialog.title}
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
          <DialogContentText
            id="alert-dialog-description"
            className={classes.contentText}
          >
            {confirmDialog.contentText}
          </DialogContentText>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            disabled={this.state.spin}
            raised={!isMobile.any}
            onClick={props.handleClose}
          >
            キャンセル
          </Button>
          <div style={{ position: "relative" }}>
            <Button
              disabled={this.state.spin}
              raised={!isMobile.any}
              className={confirmDialog.caution ? classes.cautionBtn : ""}
              onClick={() => {
                this.setState({ spin: true });
                setTimeout(() => this.setState({ spin: false }), 3000);
                confirmDialog.handleClick();
              }}
              style={{ width: "100%" }}
            >
              {confirmDialog.btnLabel}
            </Button>
            {this.state.spin && (
              <CircularProgress size={24} className={classes.buttonProgress} />
            )}
          </div>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(isMobile.any ? mobileStyles : styles)(ConfirmDialog);



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog.jsx